import React, { useState } from 'react'

// Components
import { Paragraph } from 'components/StyledComponents'

// Images
// import BlueChevronDown from 'img/snel_blue_chevron_down.svg'

// Third Party
import styled from 'styled-components'
import { DebounceInput } from 'react-debounce-input'

const NoResults = styled.div``

const Input = styled(DebounceInput)`
  outline: none;
  border: none;
  box-shadow: none;
  height: 50px;
  width: ${(props) => props.theme.width};

  ::placeholder {
    color: #c0c0c0;
  }
`
const RangeContainer = styled.div`
  width: 100%;

  ${Input} {
    width: 100%;
  }

  @media (max-width: 991px) {
    width: 100%;

    ${Input} {
      width: 100%;
      border-radius: 0;
    }
  }
`

const Separator = styled.div`
  height: 1px;
  width: 100%;
`

const RangeFilter = ({
  onChange1,
  className,
  activeFilterType1,
}) => {
  const [noResults, setNoResults] = useState(false)

  const completeSearch = (value) => {
    onChange1(value)
  }

  return (
    <div className={`filter-wrapper px-0 ${className && `${className}`}`}>
      {noResults && (
        <NoResults className="pt-2 pb-3 d-flex justify-content-center justify-content-lg-start">
          <Paragraph className="px-3 text-center py-2 color-text-light color-background-contrast font-weight-xl text-uppercase">
            Zoekopdracht is incorrect, probeer een plaatsnaam toe te voegen
          </Paragraph>
        </NoResults>
      )}
      <RangeContainer className="d-flex justify-content-center py-1 py-lg-0">
        <Input
          value={activeFilterType1}
          debounceTimeout={500}
          onChange={(e) => completeSearch(e.target.value)}
          className="px-2 font-size-18 text-uppercase font-weight-xl"
          placeholder="Plaats of adres"
        />
      </RangeContainer>
      <div className="d-flex justify-content-center pt-2 pb-1">
        <Separator className="color-background-main" />
      </div>
    </div>
  )
}

export default RangeFilter
